import { render, staticRenderFns } from "./transfer-transaction.vue?vue&type=template&id=38fcd008&"
import script from "./transfer-transaction.vue?vue&type=script&lang=js&"
export * from "./transfer-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports